// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Alert } from 'react-bootstrap'

export class AlertMessage extends Component {
    constructor(props) {
        super(props)

        this.handleDismiss = this.handleDismiss.bind(this)
        this.handleShow = this.handleShow.bind(this)

        this.state = {
            show: true
        }
    }

    handleDismiss() {
        this.setState({ show: false })
    }

    handleShow() {
        this.setState({ show: true })
    }

    render() {
        if (this.state.show) {
            return (
                <Alert bsStyle={this.props.status} onDismiss={this.handleDismiss}>
                    <p>{this.props.message}</p>
                    {this.props.children}
                </Alert>
            )
        }

        return null
    }
}


// WEBPACK FOOTER //
// ./src/components/alertMessage.js